export enum ButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  LINK = 'link',
  TRETIARY = 'tretiary'
}
